import { render, staticRenderFns } from "./onlinepay.vue?vue&type=template&id=f224faa8&scoped=true"
import script from "./onlinepay.vue?vue&type=script&lang=js"
export * from "./onlinepay.vue?vue&type=script&lang=js"
import style0 from "./onlinepay.vue?vue&type=style&index=0&id=f224faa8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f224faa8",
  null
  
)

export default component.exports